'use strict';
// B.2.3.11 String.prototype.small()
require('./_string-html')('small', function(createHTML){
  return function small(){
    return createHTML(this, 'small', '', '');
  }
});


//////////////////
// WEBPACK FOOTER
// /Volumes/Data HD/Git-UI/uikit-fullscreen/~/babel-polyfill/~/core-js/modules/es6.string.small.js
// module id = 250
// module chunks = 0